import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../common/Breadcrumbs'
import Case1 from "../../../assets/images/case-study-1.jpg"
import Case2 from "../../../assets/images/case-study-2.jpg"
import Case3 from "../../../assets/images/case-study-3.jpg"
import Line from "../../../assets/images/line.png"
import { Link, useNavigate } from 'react-router-dom'
import { axiosInstance, config } from '../config'
import { revertSlug } from '../../../utils/slugGenerator'
import Loader from "../../common/Loader"
import moment from 'moment'
import { Helmet } from 'react-helmet'

const CaseStudy = () => {

    const [casestudy , setcasestudy] = useState([]);
    const [data ,setdata] = useState([])
    const [Loading , setLoading] = useState(false);

    const Navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)
        getCustomersInfo()
        getData()
    }, [])

    function getCustomersInfo() {
        setLoading(true)
        axiosInstance.get(`casestudy`)
            .then(res => {
                setcasestudy(res?.data?.CaseStudy)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const getData = () => {
        setLoading(true)
        axiosInstance.get(`settings`)
            .then(res => {
                setdata(res?.data?.settings)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <div>
            {Loading &&  <Loader/>}
            <Helmet>
                <title>{data[4]?.metatitle || "Precision Contract Cleaning"}</title>
                <meta name="description" content={data[4]?.metadescription || "Precision Contract Cleaning"} />
                <meta name="keywords" content={data[4]?.metakeywords || "Precision Contract Cleaning"} />
            </Helmet>
            <Breadcrumbs title={data[4]?.title} description={data[4]?.subtitle} image={data[4]?.imageUrl} />

            <div className='pb-100'>
                <div class="rs-project project-style1 pt-100 mt-0">
                    <div class="sec-title text-center mb-5">
                        <span class="sub-text">Our Case Studies</span>
                        <h2 class="title">
                            Case Studies & Articles
                        </h2>
                        <div class="line-img process-center wow fadeInUp" >
                            <img src={Line} alt="Images" />
                        </div>
                    </div>
                    <div class="container">
                        <div className='row'>
                            {casestudy?.map((obj, i) => {
                                // console.log(obj?.slug)
                                return (
                                    <div className='col-md-6 col-xl-4 mb-4'>
                                        <div class="project-item">
                                            <div class="project-img">
                                                <img src={obj?.imageUrl} alt="images" className='w-100 object-fit-cover' />
                                            </div>
                                            <div class="project-content">
                                                <div class="project-inner">
                                                    <h3 class="title">
                                                        <Link to={`${config.appUrl}case-study/${obj.slug}`}>{obj?.title}</Link>
                                                    </h3>
                                                    <span class="category" dangerouslySetInnerHTML={{__html : obj.description}}></span>
                                                </div>
                                                <Link to={`${config.appUrl}case-study/${obj?.slug}`} class="p-icon"><i class="bi bi-arrow-right fs-4"></i></Link>
                                                <div><a className='bd-tab'>{moment(obj.created_at).format("MMMM D, YYYY")}</a></div>
                                                <div><a className={`bd-tab type ${obj.type == "Insights" ? "insight" : ""}`}>{obj.type}</a></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaseStudy
